import axios from 'axios';

export const CustomAxios = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, // バックエンドのベースURL
  timeout: 5000, // タイムアウト設定（任意）
  headers: {
    'Content-Type': 'application/json',
  },
});
